import React from "react";
import FileService from "../../services/FileService";
import PropTypes from "prop-types";
import { ReactComponent as IconDownload } from "./../../layout/others/icon_file.svg";

function Download({ url, fileName }) {
  function onDownloadFile(evt) {
    evt.stopPropagation();
    FileService.DownloadFileBase64(url, fileName);
  }

  return (
    <div className="col-4 text-truncate" style={{width: "360px"}}>
      <button onClick={onDownloadFile} className="action-button">
        <IconDownload />
      </button>
      {fileName}
    </div>
  );
}

Download.propTypes = {
  url: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired
};

export default Download;
